import Typography from "ds/components/Typography";

const Documentation = () => {
  return (
    <Typography tag="p" variant="p-body2">
      Stack roles allow you to grant your stack permissions to perform actions outside its own
      space. This is useful when you need your stack to access resources or trigger operations in
      other spaces.
    </Typography>
  );
};

export default Documentation;
